import { render, staticRenderFns } from "./PPPIClassement.vue?vue&type=template&id=19b570ac&scoped=true"
import script from "./PPPIClassement.vue?vue&type=script&lang=js"
export * from "./PPPIClassement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b570ac",
  null
  
)

export default component.exports